import { render, staticRenderFns } from "./cDocumentPartTagList.vue?vue&type=template&id=221f9a00&scoped=true"
import script from "./cDocumentPartTagList.vue?vue&type=script&lang=js"
export * from "./cDocumentPartTagList.vue?vue&type=script&lang=js"
import style0 from "./cDocumentPartTagList.vue?vue&type=style&index=0&id=221f9a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f9a00",
  null
  
)

export default component.exports